import {createAction, createReducer} from '@reduxjs/toolkit'
import {
  SSLErrorNotificationState,
  SSLErrorDetailsType,
  SSLType,
  SliceStatus,
  SSLErrorItemType,
} from 'interfaces'

export const sslErrorNotificationInitState: SSLErrorNotificationState = {
  byAppNotifications: {items: [], offset: 0},
  byUrlNotifications: {items: [], offset: 0},
  totalAppCount: 0,
  totalUrlCount: 0,
  selectedSSLErrorView: SSLType.app,
  status: SliceStatus.idle,
  selectedSSLErrorViewOffset: 0,
}

const getSSLErrorNotifications = createAction('getSSLErrorNotifications')
const getSSLErrorNotificationsSuccess = createAction<SSLErrorDetailsType>(
  'getSSLErrorNotificationsSuccess',
)
const getSSLErrorNotificationsFailure = createAction(
  'getSSLErrorNotificationsFailure',
)
const setSelectedSSLErrorViewType = createAction<SSLType>(
  'setSelectedSSLErrorViewType',
)

export const sslErrorActions = {
  getSSLErrorNotifications,
  getSSLErrorNotificationsSuccess,
  getSSLErrorNotificationsFailure,
  setSelectedSSLErrorViewType,
}

export const sslErrorNotificationReducer = createReducer(
  sslErrorNotificationInitState,
  builder => {
    builder
      .addCase(getSSLErrorNotifications, state => ({
        ...state,
        status: SliceStatus.pending,
      }))
      .addCase(getSSLErrorNotificationsSuccess, (state, {payload}) => {
        let byAppNotifications = {...state?.byAppNotifications},
          byUrlNotifications = {...state?.byUrlNotifications},
          totalAppCount = state?.totalAppCount,
          totalUrlCount = state?.totalUrlCount
        if (payload?.sslType === SSLType.app) {
          byAppNotifications = {items: payload?.items, offset: payload?.offset}
          totalAppCount = payload?.totalAppCount
          // only update the URL count when its current value is 0
          totalUrlCount =
            totalUrlCount === 0 ? payload?.totalUrlCount : totalUrlCount
        } else {
          byUrlNotifications = {items: payload?.items, offset: payload?.offset}
          totalUrlCount = payload?.totalUrlCount
          // only update the app count when its current value is 0
          totalAppCount =
            totalAppCount === 0 ? payload?.totalAppCount : totalAppCount
        }
        return {
          ...state,
          byAppNotifications,
          byUrlNotifications,
          totalAppCount,
          totalUrlCount,
          status: SliceStatus.resolved,
          selectedSSLErrorViewOffset: payload?.offset,
        }
      })
      .addCase(getSSLErrorNotificationsFailure, state => ({
        ...state,
        status: SliceStatus.rejected,
      }))
      .addCase(setSelectedSSLErrorViewType, (state, {payload}) => {
        let byAppNotifications = {...state?.byAppNotifications}
        let byUrlNotifications = {...state?.byUrlNotifications}
        if (payload === SSLType.app) {
          byUrlNotifications = {
            items: [...byUrlNotifications.items].map(
              resetNotificationSelectionCB,
            ),
            offset: 0,
          }
        } else {
          byAppNotifications = {
            items: [...byAppNotifications.items].map(
              resetNotificationSelectionCB,
            ),
            offset: 0,
          }
        }
        return {
          ...state,
          selectedSSLErrorView: payload,
          // when view is changed set selected view offset to 0
          selectedSSLErrorViewOffset: 0,
          byAppNotifications,
          byUrlNotifications,
        }
      })
      .addDefaultCase(state => state)
  },
)

const resetNotificationSelectionCB = (notificationItem: SSLErrorItemType) => ({
  ...notificationItem,
  isSelected: false,
  expand: false,
  childItems: notificationItem.childItems.map(childItem => ({
    ...childItem,
    isSelected: false,
  })),
})
